// screens/staff/brandLabel.ts
//
// Topbar + page-heading brand string per role. Italian role labels stay
// gender-neutral at the role level — "istruttore" is the canonical role
// name regardless of the staff member's gender. Fallback "Pannello"
// covers the loading case (me still null), which is only briefly visible.
//
// Lives in its own file because both `StaffDashboardLayout` (topbar) and
// `InstructorHomeScreen` (page heading, W6 v1.1 Session 3 item 6) need it,
// and React Refresh's `only-export-components` rule trips when a file
// exports a non-component alongside a component export.

import type { StaffRole } from '../../api/staff';

export function brandLabel(role: StaffRole | null | undefined): string {
  switch (role) {
    case 'segreteria':        return 'Pannello segreteria';
    case 'titolare':          return 'Pannello titolare';
    case 'instructor_teoria':
    case 'instructor_guida':  return 'Pannello istruttore';
    default:                  return 'Pannello';
  }
}
